import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Integrations (/integrations). Anchors live in IntegrationsPage.tsx. */
export function getIntegrationsTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Connect your tools',
        description:
          'Integrations connect outside services to your site — most importantly your MLS, so your ' +
          'real listings show up automatically.',
      },
    },
    {
      element: at('integrations-connected'),
      popover: {
        title: 'Your MLS, maps, email and texts',
        description:
          'Connect your MLS here so your real listings replace the sample ones. Below it, each ' +
          'service (Mapbox maps, Resend email, Twilio texts) has a step-by-step guide, or click ' +
          '“Do this for me” and our team will set it up.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: at('integrations-tracking'),
      popover: {
        title: 'Analytics and tracking',
        description:
          'Add Google Analytics, Tag Manager, Search Console, your Meta pixel and more, then check ' +
          'they are working on your live site. Included on Agent IDX Growth and above.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: at('integrations-add'),
      popover: {
        title: 'Other APIs',
        description:
          'Connect another service with your own API key. For your MLS, use Connect your MLS above ' +
          'instead: it asks which MLS you belong to and works out the rest.',
        side: 'bottom',
        align: 'end',
      },
    },
  ];
}
